import React from "react";
import {
  Box,
  FormElementWrapper,
  LabelStyled,
  SpanStyled,
} from "../../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { FormRadioWrapper } from "./styled";
import { Field, useFormikContext } from "formik";

const AccessType = () => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext();

  return (
    <FormElementWrapper>
      <Box className="formEleContainer">
        <LabelStyled className="labelForm">{t("access_type")}*</LabelStyled>
        <Box>
          <Box className="radiosContainer">
            <FormRadioWrapper className="archiveRadios">
              <Field
                type="radio"
                name="access_type"
                className="radio-input"
                value={1}
                checked={values.access_type === 1}
                onChange={(e) => {
                  setFieldValue("access_type", Number(e.target.value));
                }}
              />
              <Box>
                <SpanStyled
                  as="label"
                  size="16px"
                  color="var(--text)"
                  checked={Number(values.access_type) === 1}
                  className="radio-label"
                >
                  {t("viewOnly")}
                </SpanStyled>
              </Box>
            </FormRadioWrapper>
            <FormRadioWrapper className="archiveRadios">
              <Field
                type="radio"
                name="access_type"
                className="radio-input"
                value={2}
                checked={values.access_type === 2}
                onChange={(e) => {
                  setFieldValue("access_type", Number(e.target.value));
                }}
              />
              <Box>
                <SpanStyled
                  as="label"
                  size="16px"
                  color="var(--text)"
                  checked={Number(values.access_type) === 1}
                  className="radio-label"
                >
                  {t("view_download")}
                </SpanStyled>
              </Box>
            </FormRadioWrapper>
          </Box>
        </Box>
      </Box>
    </FormElementWrapper>
  );
};

export default AccessType;
